/*eslint-disable*/
import React, { useState, useEffect, forwardRef, useRef } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Pagination from "@material-ui/lab/Pagination";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

// @material-ui/icons
import AddIcon from "@material-ui/icons/AddCircle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import SearchIcon from "@material-ui/icons/Search";
import AlertIcon from "@material-ui/icons/AddAlert";
import CloseIcon from "@material-ui/icons/Close";
import DateRangeIcon from "@material-ui/icons/DateRange";
import AvTimerIcon from "@material-ui/icons/AvTimer";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import i18n from "components/Translation/Translate.js";
import Datetime from "react-datetime";
import { withNamespaces } from "react-i18next";
import { PostData } from "services/Request";
import * as Func from "services/Function";

import styles from "assets/jss/main-style.js";

/* ========== ZONE Variable ========== */
const useStyles = makeStyles(styles);

const initField = {
  code: "",
  product_code: "",
  product_id: "",
  product_name: "",
  price: "0.00",
  quantity: "0",
  amount: "0.00",
  total: "0.00",
  unit_name: "",
  filepic: "",
};

const initFind = {
  search: "",
  date_start: Func.dateAdd(-30),
  date_stop: new Date(),
  order_by: "tb.id",
  order_sort: "desc",
  status: "ALL",
  status_invoice: "ALL",
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

/* ========== ZONE Function ========== */
function SearchPo({ t, callback }) {
  const mod = "po_invoice";
  const prefix = "po";
  const classes = useStyles();

  const initHeader = [
    { code: "tb.id", name: `${prefix}.id`, order: "desc" },
    { code: "br.name_th", name: `${prefix}.branch` },
    { code: "tb.date_po", name: `${prefix}.date_po` },
    { code: "sp.name", name: `${prefix}.supplier` },
    { code: "tb.remark", name: `${prefix}.remark` },
    { code: "tb.total", name: `${prefix}.amount` },
    { code: "tb.status", name: `${prefix}.status` },
    { code: "tb.status_invoice", name: `${prefix}.status_invoice` },
  ];
  const alignValue = [0, 2, 5, 6, 7, 8, 9];
  const alignItem = [
    classes.center,
    classes.center,
    classes.right,
    classes.center,
    classes.center,
    classes.center,
    classes.center,
    classes.center,
  ];
  const cboPerPage = [
    { id: 10, name: "element.show_10_record" },
    { id: 30, name: "element.show_30_record" },
    { id: 100, name: "element.show_100_record" },
  ];

  const app = useSelector((state) => state.appState);
  const txtPrice = useRef(null);
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [field, setField] = useState(initField);
  const [find, setFind] = useState(initFind);
  const [header, setHeader] = useState(initHeader);
  const [alert, setAlert] = useState(null);
  const [notify, setNotify] = useState(null);
  const [modalEdit, setModalEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    i18n.changeLanguage(app.lang);
  }, [id]);

  const view = (data) => {
    setLoading(true);
    PostData(mod, "po", {
      token: app.token,
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      asc: data.order_sort,
      start: Func.dateFormat(data.date_start),
      stop: Func.dateFormat(data.date_stop),
      status: data.status,
      status_invoice: data.status_invoice,
      ref_id: id,
    }).then((result) => {
      if (result.status === "OK") {
        setRecord([]);

        result.data.map((item, i) => {
          setRecord((record) => [
            ...record,
            [
              item.id,
              item.branch_name,
              Func.dateDisplay(item.date_po),
              item.supplier_name,
              item.remark,
              Func.numberDisplay(item.total),
              displayStatus(item),
              displayInvoice(item.status_invoice),
              btn(item),
            ],
          ]);
        });

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const displayStatus = (item) => {
    return (
      <code className={`color-${item.color}`}>
        <i className={item.icon} /> {item.status_display}
      </code>
    );
  };

  const displayInvoice = (inp) => {
    return inp === "Y" ? (
      <CheckCircleOutlineIcon className={classes.colorSuccess} />
    ) : (
      <AvTimerIcon className={classes.colorGray} />
    );
  };

  const btn = (item) => {
    return (
      <Button
        color="primary"
        className={classes.actionButton}
        onClick={() => {
          callback(item);
          setModalOpen(false);
        }}
      >
        {t("element.add")} <AddCircleIcon />
      </Button>
    );
  };

  const renderHeader = (data) => {
    let icon = <i className="fas fa-sort"></i>;
    if (data.order === "desc") {
      icon = <i className="fad fa-sort-up"></i>;
    } else if (data.order === "asc") {
      icon = <i className="fad fa-sort-down"></i>;
    } else {
      icon = <i className="fad fa-sort"></i>;
    }

    if (data.sort === undefined || data.sort)
      return (
        <div
          onClick={() => {
            let tmp = [];
            header.map((item, i) => {
              if (data.code === item.code) {
                const ordersort = item.order === "asc" ? "desc" : "asc";
                view({ ...find, order_sort: ordersort, order_by: data.code });
                setFind({
                  ...find,
                  order_sort: ordersort,
                  order_by: data.code,
                });
                tmp[i] = {
                  code: item.code,
                  name: item.name,
                  order: ordersort,
                  sort: item.sort,
                };
              } else {
                tmp[i] = {
                  code: item.code,
                  name: item.name,
                  order: "",
                  sort: item.sort,
                };
              }
            });

            setHeader(tmp);
          }}
          style={{ cursor: "pointer" }}
        >
          {t(data.name)} {icon}
        </div>
      );
    else return <div>{t(data.name)}</div>;
  };

  const renderViewList = () => {
    return (
      <div style={{ paddingTop: "20px" }}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6}>
            <TextField
              id="search"
              fullWidth
              InputProps={{
                onChange: (e) => {
                  view({ ...find, search: e.target.value, page: 1 });
                  setFind({ ...find, search: e.target.value, page: 1 });
                },
                startAdornment: (
                  <InputAdornment position="start">
                    {t("element.search")} :
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
                autoComplete: "off",
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <Datetime
                timeFormat={false}
                dateFormat="DD/MM/yyyy"
                closeOnSelect
                value={find.date_start}
                onChange={(value) => {
                  view({ ...find, date_start: value, page: 1 });
                  setFind({ ...find, date_start: value, page: 1 });
                }}
                className={classes.center}
                renderInput={(props) => {
                  return (
                    <TextField
                      fullWidth
                      InputProps={{
                        ...props,
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            style={{ marginBottom: "4px" }}
                          >
                            {t("element.start")} :
                          </InputAdornment>
                        ),
                        endAdornment: <DateRangeIcon />,
                        autoComplete: "off",
                        readOnly: true,
                      }}
                    />
                  );
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <Datetime
                timeFormat={false}
                dateFormat="DD/MM/yyyy"
                closeOnSelect
                value={find.date_stop}
                onChange={(value) => {
                  view({ ...find, date_stop: value, page: 1 });
                  setFind({ ...find, date_stop: value, page: 1 });
                }}
                className={classes.center}
                renderInput={(props) => {
                  return (
                    <TextField
                      fullWidth
                      InputProps={{
                        ...props,
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            style={{ marginBottom: "4px" }}
                          >
                            {t("element.stop")} :
                          </InputAdornment>
                        ),
                        endAdornment: <DateRangeIcon />,
                        autoComplete: "off",
                        readOnly: true,
                      }}
                    />
                  );
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <Table
              striped
              hover
              tableHead={[
                renderHeader(header[0]),
                renderHeader(header[1]),
                renderHeader(header[2]),
                renderHeader(header[3]),
                renderHeader(header[4]),
                renderHeader(header[5]),
                renderHeader(header[6]),
                renderHeader(header[7]),
                "",
              ]}
              tableData={record}
              customHeadClassesForCells={alignValue}
              customHeadCellClasses={alignItem}
              customClassesForCells={alignValue}
              customCellClasses={alignItem}
              coloredColls={[5]}
              colorsColls={["primary"]}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel className={classes.selectLabel}></InputLabel>
              <Select
                value={find.perPage}
                onChange={(e) => {
                  view({
                    ...find,
                    page: 1,
                    perPage: e.target.value,
                    page: 1,
                  });
                  setFind({
                    ...find,
                    page: 1,
                    perPage: e.target.value,
                    page: 1,
                  });
                }}
              >
                {cboPerPage &&
                  cboPerPage.map((item) => (
                    <MenuItem
                      key={item.id}
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value={item.id}
                    >
                      {t(item.name)}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={8} lg={9} className={classes.right}>
            <Pagination
              style={{ float: "right", marginTop: "20px" }}
              count={pageTotal}
              showFirstButton
              showLastButton
              page={pageNo}
              onChange={(e, p) => {
                view({ ...find, page: p });
                setFind({ ...find, page: p });
              }}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  const renderModalOpen = () => {
    return (
      <Dialog
        open={modalOpen}
        maxWidth="xl"
        fullWidth
        keepMounted
        onClose={() => setModalOpen(false)}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogTitle
          id="modal-list-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setModalOpen(false)}
          >
            <CloseIcon className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>{t("element.add_po")}</h4>
        </DialogTitle>
        <DialogContent
          id="modal-list"
          style={{
            minHeight: "500px",
            overflowY: "scroll",
            width: "100%",
          }}
        >
          {renderViewList()}
        </DialogContent>
      </Dialog>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  /* ========== ZONE Render ========== */
  return (
    <div>
      <Button
        round
        color="primary"
        className={classes.actionButton}
        onClick={() => {
          view(find);
          setModalOpen(true);
        }}
      >
        <AddIcon />
      </Button>
      {renderModalOpen()}
      {renderLoading()}
      {alert}
      {notify}
    </div>
  );
}

export default withNamespaces()(SearchPo);
